(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeDiagnosticStudiesComponent', psychIntakeDiagnosticStudiesComponent);

    psychIntakeDiagnosticStudiesComponent.$inject = [];

    function psychIntakeDiagnosticStudiesComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeDiagnosticStudiesController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/diagnostic-studies.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeDiagnosticStudiesController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeDiagnosticStudiesController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        vm.datePickerOptions = {
            maxDate: new Date()
        };

        vm.hadAnyDiagnosticStudiesResponse = function() {
            var find = _.find(vm.workflow.answer.diagnostics, function(d) {
		        return d.checked && d.diagnosticStudy && d.diagnosticStudy.code !== "NONE";
		    });
            return find;
        };

        init();

        vm.disabledCheck = function(item) {
			var diagnostics = $scope.vm.workflow.answer && $scope.vm.workflow.answer.diagnostics;
		    if (!diagnostics || !Array.isArray(diagnostics)) {
		        return false;
		    }

		    var selectedCodes = diagnostics
		        .filter(function(d) {
		            return d.checked;
		        })
		        .map(function(d) {
		            return d.diagnosticStudy.code;
		        });
		    if (selectedCodes.length === 0) {
				return false;
			}
			if (selectedCodes.indexOf("NONE") !== -1) {
		        return item.diagnosticStudy.code !== "NONE";
		    }

            var hasOther = ["XRAY", "MRI", "CT", "EMG_NCV"].some(function(c) {
		        return selectedCodes.indexOf(c) !== -1;
		    });
		    if (hasOther) {
		        return item.diagnosticStudy.code === "NONE";
		    }
		
		    return false;
        }
    }
})();
